"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { usePopoverMode } from "./PopoverContext.js";
function PopoverPortal({ container, keepMounted, children }) {
    const mode = usePopoverMode();
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Portal, {
        container: container,
        keepMounted: keepMounted,
        children: children
    });
    return /*#__PURE__*/ jsx(Popover.Portal, {
        container: container,
        keepMounted: keepMounted,
        children: children
    });
}
export { PopoverPortal };
